import React from 'react';
import LocalPolice from '@mui/icons-material/LocalPolice';
import ThumbUp from '@mui/icons-material/ThumbUp';

import { getDateTimeString } from '@/exceed';

import { Typo } from 'uikit/content';
import { CardMeta } from 'uikit/cards';

import styles from '../styles/videosCardContent.module.scss';

const VideosCardContent = ({
  title, meta, metaIcon, reputation, voteTotal, videoType,
}) => (
  <div className={styles.content}>
    <div>
      <Typo
        element="h3"
        variant="h5"
        modifier="semi"
      >
        {title}
      </Typo>
    </div>
    <div className={styles.metaContainer}>
      {meta && <CardMeta icon={metaIcon} text={getDateTimeString(meta)} />}
      {videoType === 'video' && (
        <>
          {reputation && <CardMeta className={styles.meta} icon={<LocalPolice />} text={reputation} />}
          {voteTotal > 0 && <CardMeta className={styles.meta} icon={<ThumbUp />} text={`+${voteTotal}`} />}
          {!reputation && !voteTotal && <div className={styles.meta} />}
        </>
      )}
    </div>
  </div>
);

VideosCardContent.propTypes = {};

export default VideosCardContent;
